import { resolveEffectiveColumns, type ColumnFormatSpec } from '@capture/shared';

type ColumnLike = { name: string; order: number; format?: ColumnFormatSpec };
type MappingLike = { targetColumn: string; formatOverride?: ColumnFormatSpec };

/**
 * Builds the column → effective format map that the preview renderers consume,
 * using the SAME shared resolver the worker uses (`resolveEffectiveColumns`), so
 * in-app preview and exported output cannot diverge. (EX-2/F-053 preview-wiring
 * follow-up — closes the gap where preview applied only mapping-level overrides
 * and ignored the column contract.)
 *
 * Returns `undefined` when no format columns are available (preview then falls
 * back to its legacy value-shape behavior — e.g. formatless destinations).
 */
export function buildSpecByColumn(
  columns: ColumnLike[] | undefined,
  mappings: MappingLike[],
): Map<string, ColumnFormatSpec> | undefined {
  if (!columns || columns.length === 0) return undefined;
  const effective = resolveEffectiveColumns(columns, mappings);
  return new Map(effective.map((c) => [c.name, c.format]));
}
